import axios from '@/libs/api.request'
import config from '@/config'

const privateCloudBaseUrl = config.basePrivateCloudUrl + '/cloud/api/v1/'

export const getPrivateCloudVolume = (params) => {
  return axios.request({
    url: privateCloudBaseUrl + 'volume/',
    needPrivateCloudProjectHeader: true,
    params: params,
    method: 'get'
  })
}

export const getPrivateCloudAllVolume = (params) => {
  return axios.request({
    url: privateCloudBaseUrl + 'all_volume_list/',
    needPrivateCloudProjectHeader: true,
    params: params,
    method: 'get'
  })
}

export const detailPrivateCloudVolume = (id) => {
  return axios.request({
    url: privateCloudBaseUrl + 'volume/' + id + '/',
    needPrivateCloudProjectHeader: true,
    method: 'get'
  })
}

export const changePrivateCloudVolume = (data, id) => {
  let url = privateCloudBaseUrl + 'volume/'
  let method = 'post'
  if (id) {
    url += id + '/'
    method = 'put'
  }
  return axios.request({
    needPrivateCloudProjectHeader: true,
    url: url,
    data: data,
    method: method
  })
}

export const deletePrivateCloudVolume = (id) => {
  return axios.request({
    url: privateCloudBaseUrl + 'volume/' + id + '/',
    needPrivateCloudProjectHeader: true,
    method: 'delete'
  })
}

export const actionPrivateCloudVolume = (data, id) => {
  return axios.request({
    url: privateCloudBaseUrl + 'volume/' + id + '/action/',
    needPrivateCloudProjectHeader: true,
    data: data,
    method: 'post'
  })
}

export const getPrivateCloudVolumeType = (params) => {
  return axios.request({
    url: privateCloudBaseUrl + 'volume_type/',
    needPrivateCloudProjectHeader: true,
    params: params,
    method: 'get'
  })
}
